module.exports = {"TXTWCL_Responsible_gaming":{"id":"TXTWCL_Responsible_gaming","defaultMessage":"Gioco responsabile","track":"Responsible gaming"}}